import { Pagination, Typography, useMediaQuery } from '@mui/material';
import Box from '@mui/material/Box';
import React, { useState } from 'react';
import { CollapsibleTable } from '../../components/CollapsibleTable';
import { MainContainer } from "../../components/MainContainerComp";
import ScrollIndicatorsComp from '../../components/ScrollIndicatorsComp/ScrollIndicatorsComp';
import { useSameWidthAsPreviousElement } from '../../utils/hooks/useSameWidthAsPreviousElement';
import { theme } from '../../utils/theme';
import { IDispatchHistoryResultsData } from './DispatchHistoryResultsData';
import { paginationStyles, subHeaderStyles } from "./styled";
const cols = ['Date', 'Shift', 'Site', 'Vessel', 'Job', 'Status', 'Special Start'];

interface DispatchHistoryResultsProps {
  data: IDispatchHistoryResultsData,
  startDate: string,
  endDate: string,
}

export const DispatchHistoryResults = ({ data, startDate, endDate }: DispatchHistoryResultsProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [page, setPage] = useState<number>(1);
  const rowsPerPage = 10;
  const startIndex = (page - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const rows = data.dispatchHistory;

  const pageRows = rows ? rows.slice(startIndex, endIndex).map(({
    dispatchDate,
    job,
    shift,
    site,
    specialStart,
    status,
    vessel,
    isReplacor,
    isReplacee
  }) => {
    const statusInfo = (
      <Box>
        <Typography>{status}</Typography>
        {isReplacor && <Typography>Replacement Called</Typography>}
        {isReplacee && <Typography>Replacement Sent</Typography>}
      </Box>
    );

    return {
      dispatchDate,
      shift,
      site,
      vessel,
      job,
      status: statusInfo,
      specialStart
    }
  }) : [];

  const totalPages = rows ? Math.ceil(rows.length / rowsPerPage) : 0;
  const [elementRef] = useSameWidthAsPreviousElement();

  const onPageChange = (event: React.ChangeEvent<unknown>, page: number) =>
    setPage(page);

  return (
    <MainContainer>
      <Typography sx={subHeaderStyles} data-automation="start-date">Start Date: {startDate} - End Date: {endDate}</Typography>
      <Typography 
        component={'div'} 
        variant='container' 
        data-automation="data-container"
      >
        <ScrollIndicatorsComp>
          <CollapsibleTable
            cols={cols.map(title => ({ title }))}
            rows={pageRows}
            isOneLevel={true}
          />
          {totalPages > 1 && <Pagination
            ref={elementRef}
            sx={paginationStyles}
            onChange={onPageChange}
            color="primary"
            count={totalPages}
            variant="outlined"
            shape="rounded"
            size={isMobile ? 'small' : 'medium'}
          />}
        </ScrollIndicatorsComp>
      </Typography>
    </MainContainer>
  )
}